module.exports = __webpack_public_path__ + "img/827-bb3d16.png";